<template>

    <v-card
      width="100%"     
      flat
      class=" text-center overflow-y-auto"
    >
    <v-card-text class="pt-0"> 
      <v-row justify="center" class="ma-0">
        <v-col cols="12" sm="12" xs="12" lg="10" xl="10">
      <v-row class="ma-0">
      <v-col cols="12" >
              <v-row align="center" justify="center" >
                <v-col
                  class="px-0"

                >
            <v-btn block small text  @click="selectCategory(-1)"  class=" btn-grp-sel topmnu-btn-blk" :class="{ active: selectGrpId === -1 }">
              ВСЕ
            </v-btn>

                </v-col>
                <v-col
                  v-for="(shopItem,gri) in servCat"
                  :key="gri"
                  class="px-0"
                  cols="6"
                  sm="4"
                  md="4"
                  lg="4"
                  xl="4"

                >
            <v-btn block small text  @click="selectCategory(gri)"  class=" btn-grp-sel topmnu-btn-blk" :class="{ active: selectGrpId === gri }">
              {{shopItem.namesubcat}} 
            </v-btn>

                </v-col>
              </v-row>
            </v-col>
      </v-row>

<v-row justify="center">
  <v-col cols="12">
    <v-row justify="center">
      <v-col cols="4" sm="2" md="3" lg="2" xl="2" :key="`nserv-`+nserv" v-for="(itemServ,nserv) in selectGrpId === -1? servAllCat : servCat[selectGrpId].objects ">
                 <v-hover
                    v-slot:default="{ hover }"
                    open-delay="100"
                  >
              <v-card  
              tile 
              class=" text-center"
              :elevation="hover ? 16 : 2"
              @click="slectShopFromAllServ(itemServ)"
              >
              <v-row align="start" justify="center" class="ma-0 pa-0">
                <v-img
                  :src="`http://api.trcgagarinsky.ru/terminal__tmp/`+itemServ.logo"
                        aspect-ratio="2.0"
                        class="white  ma-2"
                        contain
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular indeterminate color="grey darken-1"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-row>

                      <v-row align="end" justify="center" class="fill-height ma-0">
                        <v-col class="pa-0" >
                          <div class="mx-1 name-shop-img pb-1">{{ itemServ.title  }}</div> 
                        </v-col>
                      </v-row>
                      <v-row align="end" justify="center" class="fill-height ma-0">
                        <v-col class="pa-0" >

                         
                          <div class="mx-1 empty-sale pb-1">   </div> 
                        </v-col>
                      </v-row>


              </v-card>
              </v-hover>
      </v-col>
    </v-row>

  </v-col>
</v-row>

        </v-col>
      </v-row>   
       </v-card-text>
    <SeoBlock
      :seotxt1="allPages.seo_text_1"
      :seotxt2="allPages.seo_text_2"
      :seogallery="allPages.seo_images"
    />
    </v-card>
</template>
<script>
import Vue from 'vue'
import Vuex from 'vuex'
import router from 'vue-router'
import axios from "axios"
import SeoBlock from "@/components/SeoBlock"
Vue.use(Vuex)

export default {
  name: 'AllServices',
  components: {
    SeoBlock,
  },
  data () {
    return {
      fixed: false,
      tabsmod: 'all',
      selectGrpId: -1,
      servCat: null,
      servAllCat: null,

    }
  },

          metaInfo: {
          title: 'Услуги -',

        },

     computed:{
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },       
      isMobile: {
      get () {
        return this.$store.state.app.isMobile
      }
      
    },       
        loadPathData: {
          get () {
            return this.$store.getters.getLoadPathData
          }
          
        },        
        shops() {  
          let allShops= this.$store.state.shops.shops;
          let filterOnly = allShops.filter((allI)=>{
           return (!allI.category.includes('50') && !allI.category.includes('43') && !allI.category.includes('37'));
          });
          if(DEBUG) console.log('filterOnly :', filterOnly);
            return filterOnly;
          },
        categories: {
          get () {
            if(DEBUG) console.log('this.$store.state.category :', this.$store.state.category.categories);
            return this.$store.state.category.categories
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('updateCategory', val)
          }
        },
        titleInnert: {
          get () {
            if(DEBUG) console.log('this.$store.state.category :', this.$store.state.app.titleInner);
            return this.$store.state.app.titleInner;
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('setTitleInner', val)
          }
        },
        allPages: {
          get() {
            const vApp = this;
            let getAllPages = vApp.$store.getters.getAllPages;
            const slugPage = vApp.$route.path.slice(1);
            if(DEBUG) console.log("path slug :>> ", vApp.$route.path);
            if(DEBUG) console.log(" slugPage :>> ", slugPage);
            if(DEBUG) console.log(" getAllPages :>> ", getAllPages);
            if(DEBUG) console.log(
              "this.$store.getters.getAllPages :>> ",
              getAllPages.find((sp) => sp.slug === slugPage)
            );
            return getAllPages.find((sp) => sp.slug === slugPage);
          },
          set(val) {
            let vApp = this;
            vApp.$store.dispatch("setAllPages", val);
          },
        },        
     },  
  methods: {
      sortArray(array, property, direction) {
      direction = direction || 1;
      array.sort(function compare(a, b) {
          let comparison = 0;
          if (a[property] > b[property]) {
              comparison = 1 * direction;
          } else if (a[property] < b[property]) {
              comparison = -1 * direction;
          }
          return comparison;
      });
      return array; // Chainable
  },
    removeDuplicates(array, key){
            return array.reduce((arr, item) => {
                    const removed = arr.filter(i => i[key] !== item[key]);
                    return [...removed, item];
                  }, []);
    },
      slectShopFromAllServ(nShop){
        let vApp = this;
        if(DEBUG) console.log('nShop :', nShop);
        vApp.currentShop = nShop;            
        vApp.$router.push('/'+vApp.loadPathData.mnuServicePath+'/'+nShop.slug);
      },

      selectCategory(numCat){
        let vApp = this;
        if(DEBUG) console.log('Select numCat :', numCat);
        if(DEBUG) console.log('vApp.servCat :', vApp.servCat);
        
        if(numCat === -1){
        vApp.titleInnert = "УСЛУГИ";
        }
        else{
          if(DEBUG) console.log('             ##########ПУТЬ :', "/" + vApp.loadPathData.mnuServicePath+'/category/'+vApp.servCat[numCat].slug);
          vApp.titleInnert = vApp.servCat[numCat].namesubcat;
          vApp.$router
            .push({
              path: "/" + vApp.loadPathData.mnuServicePath+'/category/'+vApp.servCat[numCat].slug,
            })
            .catch(() => {
              if(DEBUG) console.log("error Select Filter route 2");
            });          
        }
        
          vApp.selectGrpId = numCat;  

        
      },
     },
   
  mounted () {    
    if(DEBUG) console.log('mounted All Shops ')
    let vApp = this
    this.$nextTick(function () {      
      if(DEBUG) console.log('mounted AllServises');
      vApp.titleInnert = 'УСЛУГИ';
      if(vApp.shops === null){
        axios({
              method: "get",
              url: "http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_all_shops/json"

            })
              .catch(function(error) {
                if(DEBUG) console.log("ERROR: ", error);
              })
              .then( function(response) {
                  if(DEBUG) console.log("response dataAllShops =",response.data );
                vApp.$store.dispatch("loadShops",response.data);

                });
      }
        axios({
              method: "get",
              url: "http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_categories_with_shops"

            })
              .catch(function(error) {
                if(DEBUG) console.log("ERROR: ", error);
              })
              .then( function(response) {
                  if(DEBUG) console.log("response dataAll Category = ",response.data );

                vApp.$store.dispatch("updateCategory",response.data);
                

                vApp.grpShop = response.data[0].category;

                vApp.servCat =  response.data[3].category.filter((allI)=>{
                  if(DEBUG) console.log('filter allI :', allI);
                return (allI.objects.length > 0);
                });
                if(DEBUG) console.log('vApp.servCat :', vApp.servCat);
                let allServ = [];
                let arrAll = vApp.servCat.map(arrSh=>arrSh.objects);
                for (let ix = 0; ix < arrAll.length; ix++) {
                  const elix = arrAll[ix];
                      allServ.push(...elix);
                      
                  
                }
                vApp.servAllCat = vApp.removeDuplicates(allServ,'id');
                vApp.servAllCat = vApp.sortArray(vApp.servAllCat,"title");
                if(DEBUG) console.log('allServ :', vApp.removeDuplicates(allServ,'id'));

                vApp.selectCategory(-1);
                });

      let scrollEl = document.querySelector('#scrollT');
      scrollEl.scrollTo(0,0);

    })
  }     
}
</script>
<style  scope>
.name-shop-img{
  line-height: 1.1;
  min-height: 36px;
}

.ramka{
  width: 90%;
  height: 90%;
}
.empty-sale{
  min-height: 28px;
}
.sceleton-img{
  max-height: 160px;
}
</style>